@if (viewStateLoaded()) {
    <button
        mat-icon-button
        class="st-playbook-secondary-cta-button-save-as"
        [matTooltip]="languageSettings.PSTWebSaveViewSettings"
        [disabled]="isSaveButtonDisabled()"
        [matMenuTriggerFor]="menu">
        <mat-icon class="material-symbols-outlined">save_as</mat-icon>
    </button>
    <button
        mat-icon-button
        class="st-playbook-secondary-cta-button-copy"
        [matTooltip]="languageSettings.PSTWebCopyViewToClipboard"
        (click)="copyToClipboard()">
        <mat-icon class="material-symbols-outlined">file_copy</mat-icon>
    </button>
    @if (shouldShowCustomFieldsOption() && selectViewStateType() === viewStateTypes.TOPIC) {
        <button
            mat-icon-button
            class="st-playbook-secondary-cta-button-one"
            [disabled]="!isSupervisor()"
            [matTooltip]="languageSettings.PSTWebCustomizeTopicCard"
            (click)="openTopicCardCustomFieldsDialog()">
            <mat-icon class="material-symbols-outlined">rule</mat-icon>
        </button>
    }
    @if (selectViewStateLayout() === ViewStateLayouts.GRID) {
        <button
            mat-icon-button
            class="st-playbook-secondary-cta-button-one"
            [matTooltip]="languageSettings.PSTWebCustomizeGridColumns"
            (click)="editView()">
            <mat-icon class="material-symbols-outlined">settings</mat-icon>
        </button>
    }
    <mat-menu
        #menu="matMenu"
        class="st-playbook-secondary-cta-menu">
        <ng-template matMenuContent>
            <button
                mat-menu-item
                [disabled]="!saveViewSettingsEnabled()"
                (click)="saveViewState()">
                {{ languageSettings.PSTWebSaveViewSettings }}
            </button>

            <button
                mat-menu-item
                [disabled]="!saveAsViewSettingsEnabled()"
                (click)="saveAsViewState()">
                {{ languageSettings.PSTWebSaveAsViewSettings }}
            </button>
        </ng-template>
    </mat-menu>
}
